import { apiRequest } from "../../services/apiService";
import {
    GET_EMAIL_TEMPLATE_REQUEST, GET_EMAIL_TEMPLATE_SUCCESS, GET_EMAIL_TEMPLATE_FAIL,
    UPSERT_EMAIL_TEMPLATE_REQUEST, UPSERT_EMAIL_TEMPLATE_SUCCESS, UPSERT_EMAIL_TEMPLATE_FAIL,
    DELETE_EMAIL_TEMPLATE_REQUEST, DELETE_EMAIL_TEMPLATE_SUCCESS, DELETE_EMAIL_TEMPLATE_FAIL,
    TOGGLE_REPORT_EMAIL_REQUEST, TOGGLE_REPORT_EMAIL_SUCCESS, TOGGLE_REPORT_EMAIL_FAIL
} from "../constant";

export const getEmailTemplate = (data) => {
    return async (dispatch) => {
        dispatch({ type: GET_EMAIL_TEMPLATE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: '/survey/getEmailTemplate',
            data
        });
        if (response) {
            dispatch({ type: GET_EMAIL_TEMPLATE_SUCCESS, payload: response.data?.data });
        } else if (error) {
            dispatch({ type: GET_EMAIL_TEMPLATE_FAIL });
        }
    };
};

export const upsertEmailTemplate = (data, successCallback = () => {}) => {
    return async (dispatch) => {
        dispatch({ type: UPSERT_EMAIL_TEMPLATE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: '/survey/upsertEmailTemplate',
            data
        });
        if (response) {
            dispatch({ type: UPSERT_EMAIL_TEMPLATE_SUCCESS, payload: data });
            successCallback();
        } else if (error) {
            dispatch({ type: UPSERT_EMAIL_TEMPLATE_FAIL });
        }
    };
};

export const deleteEmailTemplate = (data, successCallback = () => {}) => {
    return async (dispatch) => {
        dispatch({ type: DELETE_EMAIL_TEMPLATE_REQUEST });
        const { response, error } = await apiRequest({
            method: 'DELETE',
            url: '/survey/deleteEmailTemplate',
            data
        });
        if (response) {
            dispatch({ type: DELETE_EMAIL_TEMPLATE_SUCCESS });
            successCallback();
        } else if (error) {
            dispatch({ type: DELETE_EMAIL_TEMPLATE_FAIL });
        }
    };
};

export const toggleReportEmail = (survey_id, email_enabled, successCallback = () => {}) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_REPORT_EMAIL_REQUEST });
        const { response, error } = await apiRequest({
            method: 'POST',
            url: '/survey/toggleReportEmail',
            data: { survey_id, email_enabled }
        });
        if (response) {
            dispatch({ type: TOGGLE_REPORT_EMAIL_SUCCESS, payload: email_enabled ? 1 : 0 });
            successCallback();
        } else if (error) {
            dispatch({ type: TOGGLE_REPORT_EMAIL_FAIL });
        }
    };
};
